import type { Ref } from 'vue';

import type { AemData, AemFeatureElement } from '../lib/types/aem';
import type { SimpleListItemModel, SimpleListProps } from '../components/SimpleList/SimpleList.types';
import type { Feature } from '../lib/api/api';

/* istanbul ignore file for now */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useVehicleFeaturesWithSimpleList(aemData: Ref<AemData>) {
  function buildSimpleListProps(features: Feature[]): SimpleListProps {
    return {
      items: features.map<SimpleListItemModel>((feature: Feature) => {
        let aemFeatureElement: AemFeatureElement | undefined;

        if (aemData?.value.featureElements) {
          aemFeatureElement = aemData.value.featureElements.find(
            (featureElement: AemFeatureElement) => featureElement.code === feature.equipmentId,
          );
        }

        return {
          id: feature.equipmentId,
          image: {
            source: feature.imageUrl,
            title: feature.title,
            description: feature.description,
            ratio: '3x4',
          },
          headline: feature.title,
          description: feature.description,
          buttonData: {
            label: aemFeatureElement?.ctaButtonText || '',
          },
        };
      }),
    };
  }

  return {
    buildSimpleListProps,
  };
}
